<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <select type="text" @change="updateValue($event.target.value)" :name="name" :required="required" class="form-control">
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <option v-if="Array.isArray(cities)" v-for="city in cities" :value="city.id" :selected="value == city.id">{{ city.name }}</option>
    </select>
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputCities',
    props: ['name', 'value', 'state', 'required', 'label', 'placeholder', 'error'],
    methods: {
      updateValue (value) {
        this.stateId = value
        this.$emit('input', value)
      },
      getCities () {
        if (this.state) {
          return this.$http.get('cities?state_id=' + this.state)
            .then(response => response.data.data, () => false)
        } else {
          return new Promise(() => false, () => false)
        }
      }
    },
    watch: {
      state (value) {
        if (this.value) {
          this.cities = false
          // this.cities = this.getCities()
        }
      }
    },
    asyncComputed: {
      cities: {
        get () {
          return this.getCities()
        },
        default: false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputCities.vue?50e71109